<form [formGroup]="exceptionalItemsDisclosureFg">
  <div class="row">
    <div class="col col-1 pt-3" style="width: 400px">
      <p style="padding: 6px">Informatieverschaffing over bijzondere posten</p>
    </div>
    <div class="col-2 pt-3">
      <snelstart-ui-button type="secondary"
                           icon="{{ this.exceptionalItemsDisclosureFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                           class="custom-input-150"
                           (click)="this.showDialog(1)">
        {{ this.exceptionalItemsDisclosureFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
      </snelstart-ui-button>
    </div>
    @if (isRechtspersoon) {
      <div class="col-3">
        <snelstart-ui-select-form-control formControlName="includeInKvkReport"
                                          label="In publicatiestukken"
                                          [options]="this.optionsJaNee"
                                          [required]=true
                                          [disabledControl]="!this.jrDataService.isLegalSizeMediumOrLarger()"
                                          class="me-1 custom-input-150"
                                          (change)="this.saveForm()"
        >
        </snelstart-ui-select-form-control>
      </div>
    }
  </div>
</form>

<div *ngIf="this.index === 1">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanation [(dialogVisible)]="this.dialogVisible"
                                                               [(input)]="this.exceptionalItemsDisclosureFg"
                                                               [title]="'Informatieverschaffing over bijzondere posten in de winst-en-verliesrekening '"
                                                               (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanation>
</div>

